
import { Mixins, Component, Ref, Prop, Watch } from "vue-property-decorator";
import loading from "@/mixins/loading";
import { Form } from "element-ui/types";
// TODO: 替换为实际的接口
// import { getWeightDetailById, editWeightDetail } from "@/api/twoHour";

@Component({ components: {} })
export default class WeightEditDialog extends Mixins(loading) {
  @Ref("validateForm") validateForm: Form;
  @Prop([Boolean]) private dialogVisible!: boolean;
  @Prop([Number]) private id!: number;

  formData = {
    time: "",
    name: "",
    fatReduction: "",
    fatReductionDesc: "",
    fatGain: "",
    fatGainDesc: "",
    fatCore: "",
    fatPrinciple: "",
  };

  rules = {
    fatReduction: [
      { required: true, message: "请输入减脂必做", trigger: "blur" },
    ],
    fatReductionDesc: [
      { required: true, message: "请输入必做说明", trigger: "blur" },
    ],
    fatGain: [
      { required: true, message: "请输入发胖雷区", trigger: "blur" },
    ],
    fatGainDesc: [
      { required: true, message: "请输入雷区说明", trigger: "blur" },
    ],
    fatCore: [
      { required: true, message: "请输入减脂核心", trigger: "blur" },
    ],
    fatPrinciple: [
      { required: true, message: "请输入减脂原理", trigger: "blur" },
    ],
  };

  dialogClose() {
    this.validateForm?.resetFields();
    this.$emit('closeEditDialog');
  }

  saveData() {
    this.validateForm?.validate().then((valid) => {
      if (valid) {
        const params = {
          ...this.formData,
          time: undefined,
          name: undefined
        }
        this.showLoading();
        // TODO: 替换为实际的编辑接口
        // editWeightDetail(params).then((res) => {
        //     this.$message.success("保存成功");
        //     this.$emit('editDialogConfirm');
        // }).finally(() => {
        //     this.hideLoading();
        // })
        this.$message.success("保存成功");
        this.$emit('editDialogConfirm');
        this.hideLoading();
      }
    })
  }

  @Watch("dialogVisible", { immediate: true })
  getData() {
    if(this.dialogVisible != true) return;
    // TODO: 替换为实际的详情接口
    // getWeightDetailById({ id: this.id }).then((res) => {
    //   this.formData = res.data || {};
    //   const startTime = res.data.startTime.slice(0, 5);
    //   const endTime = res.data.endTime.slice(0, 5);
    //   this.formData.time = startTime + " - " + endTime;
    // })
  }
}
